import executeViaClientEVM from './executeViaClientEVM';
import executeViaClientSolana from './executeViaClientSolana';
export default async function executeViaClient(args, isSolana) {
  if (isSolana) {
    return executeViaClientSolana(args);
  } else {
    return executeViaClientEVM(Object.assign(Object.assign({}, args), {
      skipSimulation: true
    }));
  }
}